import { Skeleton } from 'primereact/skeleton';

/**
 * The standard loading placeholder for a detail or form page.
 *
 * Shows the shape of the screen — a title, a couple of cards, a field grid — as
 * shimmering bars while the record loads, so the page reads as filling in rather
 * than spinning. Replaces the per-page ProgressSpinner used on initial fetch.
 */
const PageSkeleton = () => (
  <div className="w-full max-w-5xl space-y-3 p-4" data-testid="PageSkeleton">
    <Skeleton width="8rem" height="1.4rem" />

    <div className="space-y-3 rounded-xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <Skeleton width="14rem" height="1.6rem" />
      <Skeleton width="10rem" height="0.9rem" />
      <div className="grid grid-cols-1 gap-4 pt-2 sm:grid-cols-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} height="2.4rem" />
        ))}
      </div>
    </div>

    <div className="space-y-3 rounded-xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <Skeleton width="10rem" height="1.2rem" />
      {Array.from({ length: 3 }).map((_, i) => (
        <Skeleton key={i} height="2.4rem" />
      ))}
    </div>
  </div>
);

export default PageSkeleton;
